import { dashboard } from '@breezeway/brzw-react-core';

export default (state = {}, action) => {
  const { date, filters, propertyReservations, propertyTasks } = state;
  return {
    date: dashboard.reducers.date(date, action),
    filters: dashboard.reducers.filters(filters, action),
    propertyReservations: dashboard.reducers.propertyReservations(propertyReservations, action),
    propertyTasks: dashboard.reducers.propertyTasks(propertyTasks, { ...action, date }),
  };
};
